export const SIDEBAR_SECTIONS_WIDTH = 48
export const SIDEBAR_CONTENT_WIDTH = 280
export const SIDEBAR_RETRACTION_ANIMATION_DELAY = 200
export const HEADER_HEIGHT = 70
